import { Component, OnInit, OnDestroy, Renderer2, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';

import { SharedService } from '../shared/services/shared.service';
import { ThemeService } from '../shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  title: string = 'Deesha_Web';
  currentTheme: string = 'deesha';
  
  public isHeld : boolean|null = null;
  public underMaintenance: boolean|null=null;
  public holdingDate: Date | null = null;
  

  private unlistenPopState?: () => void;
  private destroyRef = inject(DestroyRef);

  constructor(
    private renderer: Renderer2,
    private toasterService: ToastrService,
    public sharedService: SharedService,
    private themeService: ThemeService
  ) {
    // 1. Safe Event Listener Attachment via Renderer2
    this.unlistenPopState = this.renderer.listen('window', 'popstate', () => {
      this.toasterService.warning("Browser back is restricted!. Application will be logged out.");
      this.sharedService.logout();
    });

    // 2. Auto-Unsubscribing RxJS Subscriptions
    var i=0;
    this.sharedService.holdingState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ underMaintenance, holdingDate }) => {
        this.holdingDate = holdingDate;
        this.underMaintenance = underMaintenance;
        if(holdingDate==null && underMaintenance==null)
        {
          this.isHeld=null;
        }
        else if(underMaintenance==true)
        {
          this.isHeld=true;
        }
        else if(this.isHeld==null)
        {
          this.isHeld = (holdingDate!=null);
        }
      });


    this.sharedService.themeSource$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([themeName]) => {
        this.themeService.toggleTheme(this.renderer, themeName);
      });
  }

  ngOnInit(): void {
    this.applyStartupTheme();
    this.sharedService.startTokenTimer();
  }

  logout() {
    this.sharedService.logout();
  }

  continue() {
    this.isHeld=false;
    this.sharedService.getUpdatedNotification(true, false);
  }

  applyStartupTheme(): void {
    const savedTheme = this.sharedService.getThemePreference();
    this.themeService.toggleTheme(this.renderer, savedTheme ?? '');
  }

  ngOnDestroy(): void {
    // Clean up window event listener on component destroy
    if (this.unlistenPopState) {
      this.unlistenPopState();
    }
  }
}